const TIME_OUT = 2000;

export { TIME_OUT };
